import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ApiResult } from '../models/api/api-result.model';
import { ProjectItemModel } from '../models/dataman/ProjectItem.model';
import { ProjectDetailModel } from '../models/dataman/ProjectDetailModel.model';
import { PromptResult } from '../models/dataman/PromptResult.model';
import { DataCodeRequest } from '../models/dataman/DataCodeRequest.model';
import { DataCodePreviewModel } from '../models/dataman/DataCodePreviewModel.model';
import { DataCodeHistoryDeleteModel } from '../models/dataman/DataCodeHistoryDeleteModel.model';
import { EnmProjectType } from '../models/enums/EnmProjectType.enum';
import { MultiViewModel } from '../models/dataman/Reports/MultiViewModel.model';
import { UserDashboardDataModel } from '../models/dashboard/UserDashboardData.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {



  constructor(private readonly apiService: ApiService) {
  }

  public GetDashboard(): Observable<ApiResult<UserDashboardDataModel>> {

       return this.apiService.postnull<UserDashboardDataModel>('/dashboard');
  }


    public GetMarletplaceApplications(): Observable<ApiResult<MarketplaceApplication[]>> {

       return this.apiService.postnull<MarketplaceApplication[]>('/marketplace-applications');
  }

}